import React from 'react';
import { Card, Row } from 'react-bootstrap';
import { Testo, SolaLettura } from './campi';
import { statoAttuale } from './modificaAnagrafica';
import { bmiClass } from '../../Util/enum';

/*
 * Tab «Forma fisica» in modifica (player e junior): peso, altezza e numero di piede dello stato attuale.
 * Al salvataggio parte un solo stato (come dalle app): il server calcola BMI e classe dal sesso, che quindi serve.
 * BMI, classe e data dell'ultimo aggiornamento si vedono in sola lettura.
 * Props: modifica (useModificaAnagrafica), tipo.
 */
const FormaFisicaModifica = ({ tipo, modifica }) => {
    const { f, imposta, profiloPrivato } = modifica;
    const campo = (chiave) => ({ id: chiave, valore: f[chiave], onChange: (v) => imposta(chiave, v) });
    const decimale = { tipo: 'number', min: 0, step: 0.1, inputMode: 'decimal' };

    const ramo = profiloPrivato ? (tipo === 'junior' ? profiloPrivato.junior : (profiloPrivato.idsPlay || profiloPrivato.idsGuru)) : null;
    const stato = statoAttuale(ramo && ramo.states);
    const bmi = stato && stato.bodyMassIndex != null ? Number(stato.bodyMassIndex).toFixed(1).replace('.', ',') : '';
    const classe = stato ? ((bmiClass.find((c) => c.value === stato.bodyMassIndexClass) || {}).label || '') : '';
    const data = stato && stato.updatedAt
        ? new Date(stato.updatedAt).toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '';

    return (
        <Card>
            <Card.Body className="sid-card-body--spaced">
                <h5 className="sid-form-section">Forma fisica</h5>
                <Row className="g-4">
                    <Testo {...campo('weight')} {...decimale} etichetta="Peso (kg)" larghezza={4} />
                    <Testo {...campo('height')} {...decimale} etichetta="Altezza (cm)" larghezza={4} />
                    <Testo {...campo('footNumber')} {...decimale} step={0.5} etichetta="N° piede" larghezza={4} />
                    <SolaLettura etichetta="BMI" valore={bmi} larghezza={4} />
                    <SolaLettura etichetta="Classe BMI" valore={classe} larghezza={4} />
                    <SolaLettura etichetta="Data aggiornamento" valore={data} larghezza={4} />
                </Row>
            </Card.Body>
        </Card>
    );
};

export default FormaFisicaModifica;
